import { render } from "./Common.vue?vue&type=template&id=cb78f1e8&scoped=true"
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"

import "./Common.vue?vue&type=style&index=0&id=cb78f1e8&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb78f1e8"]])

export default __exports__